import React, { Component, useEffect, useState, forwardRef, useRef, useImperativeHandle } from 'react';
import { qr_code } from '../../Images';
import moment from 'moment';
import { NumberFormat } from '../../Components/NumberFormat';
import angkaTerbilang from '@develoka/angka-terbilang-js';
import { REACT_APP_BASE_URL } from '../../Constants';

const PrintTransfer = forwardRef((props, ref) => {
    const { getState, login } = props;
    const pageStyle =" @page { size: A4 portrait; margin: 20;}";
    const [qrCode, setQrCode] = useState("");
    const base_url = REACT_APP_BASE_URL;

    useEffect(() => {
        let word = `${base_url}estatement/inventory-receipt/${getState.docnum}`;
        setQrCode
     ('https://api.qrserver.com/v1/create-qr-code/?data=' + word+ '&size=400x400&bgcolor=ffff');
    },[getState]);

    let total = 0;
    for(const x in getState.products){
        total += getState.products[x].qty;
    }
    return (
        
        <div id="content" ref={ref} style={{color: '#000', backgroundColor: '#fff'}}>
            <style>{pageStyle}</style>
            <div style={{display: 'flex', flexWrap:'wrap', padding: 15}} >
                <div style={{width: '50%'}}>
                    <h2 style={{color: '#000'}}>{login.BPLFrName}</h2>
                    {login.legal_name && <h4>{login.legal_name}</h4>}
                    <p>{login.Address}
                        &nbsp; Telp {login.phone}</p>
                </div>
                <div style={{width: '10%'}}></div>
                <div style={{width: '40%', textAlign: 'right'}}>
                    <div style={{display: 'flex', flexWrap:'wrap', padding: 0}} >
                        <div style={{width: '70%', paddingRight:10,marginRight:0}}>
                            <h2 style={{fontSize: 18, fontWeight: 'bold'}}>No Receipt : <br/>
                            {getState.docnum}</h2>
                            <p style={{margin: 0}}>Tgl Dikirim : { moment(getState.docdate).format('DD MMMM YYYY') }</p>
                        </div>
                        <div style={{width: '30%', paddingLeft:0, marginLeft: 0}}>
                            <img src={qrCode} width={100} />
                        </div>
                    </div>
                    
                </div>
               
            </div>
            <div className='row justify-content-center' >
                <div style={{fontSize: 24, fontWeight: 'bold', color: '#000'}}> STOCK TRANSFER</div>
            </div>
            <hr />
            <div className='row'>
                <div className='d-block' style={{width: '100%'}}>
                    <div style={{fontSize: 21, fontWeight: 'bold', paddingLeft: 50, float: 'left'}}> From : {getState.fromWhsName}</div>
                    <div style={{fontSize: 21, fontWeight: 'bold', paddingRight: 30, float: 'right'}}> To : {getState.toWhsName}</div>
                </div>
            </div>
            <div className='row' style={{margin: 10, padding: 10}}>
                <table className='table'>
                    <thead>
                        <tr>
                            <td style={{color: '#000'}}>NO</td>
                            <td style={{color: '#000'}}>Product</td>
                            <td style={{color: '#000'}}>Quantity</td>
                        </tr>
                    </thead>
                    <tbody>
                    {getState.products.map((row, index) => 
                        (
                        <tr key={`tr-` + index} style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                                <td style={{borderTop: 'none', color: '#000'}}>{index+1}</td>
                                <td style={{borderTop: 'none', color: '#000'}}>{row.itemname}</td>
                                <td style={{borderTop: 'none', color: '#000'}}>{row.qty}</td>
                        </tr>
                    ))}
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 5, color: '#000'}} colSpan={2}>Total</td>
                            <td style={{borderTop: 'none', textAlign: 'left', paddingTop: 0, paddingBottom: 0, color: '#000'}}>{total}</td>
                        </tr>
                       
                    </tbody>
                </table>
                
            </div>
            <div style={{display: 'flex', flexWrap:'wrap', padding: 15}} >
                <div className='row' style={{width: '50%', textAlign: 'center'}}>
                    <div style={{width: '100%', paddingBottom: 100}}>Tanda Tangan Konsumen</div><br/>
                    <div style={{width: '100%'}}>______________________</div>
                </div>
                <div className='row' style={{width: '50%', textAlign: 'center'}}>
                    <div style={{width: '100%', paddingBottom: 100}}>Tanda Tangan Toko</div><br/>
                    <div style={{width: '100%'}}>______________________</div>
                </div>
            </div>
        </div>
  )
});

export default PrintTransfer;